import { FileInput } from 'entities/FileInput'
import { useConfigStore } from 'shared/store/configSlice'

export const LogoImagePickerTR = () => {
  const logoImage = useConfigStore().config?.tableReservationConfig?.logoImage
  const updateTableReservationConfig = useConfigStore().updateTableReservationConfig

  const updateImage = (value: string) => {
    updateTableReservationConfig({ logoImage: value })
  }

  return (
    <div>
      <FileInput
        id='TRlogoImage'
        title='Logo Image'
        height={200}
        width={355}
        background={logoImage}
        onChange={updateImage}
      />
    </div>
  )
}
